module.exports = __webpack_public_path__ + "img/page13.140ae418.png";